var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelTrends(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 10.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#999;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    className: "cls-1",
    d: "M16.4,0c-.9,0-1.6,.7-1.6,1.6,0,.3,.1,.7,.3,.9l-2.9,4.9c-.4-.1-.8-.1-1.2,0L7.9,2.3c.3-.6,.2-1.3-.3-1.8C7.3,.2,6.9,0,6.4,0h0c-.4,0-.8,.2-1.2,.5-.6,.6-.7,1.4-.2,2.1L2.2,7.5c-.2,0-.4,0-.5,0h0c-.4,0-.8,.2-1.2,.5-.6,.6-.7,1.6,0,2.3,0,0,0,0,0,0,.3,.3,.7,.5,1.2,.5h0c.4,0,.8-.2,1.2-.5,.6-.6,.7-1.6,0-2.2L5.7,3.1h0c.2,.1,.5,.2,.7,.2h0c.4,0,.7-.1,1-.3l3,5.1c-.3,.3-.4,.7-.4,1,0,.9,.8,1.6,1.7,1.6,.9,0,1.6-.7,1.6-1.6,0-.4-.2-.8-.4-1.1l2.8-4.9h0c.2,.1,.5,.2,.7,.2,.9,0,1.6-.7,1.6-1.6S17.3,0,16.4,0h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelTrends);
export default __webpack_public_path__ + "static/media/channel-trends.1946c05f3323a9485b3ccf6f473aab78.svg";
export { ForwardRef as ReactComponent };